import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.1",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 266.893 266.895",
  "enable-background": "new 0 0 266.893 266.895",
  "xml:space": "preserve"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  id: "Blue_1_",
  fill: "#3C5A99",
  d: "M248.082,262.307c7.854,0,14.223-6.369,14.223-14.225V18.812\r\n\tc0-7.857-6.368-14.224-14.223-14.224H18.812c-7.857,0-14.224,6.367-14.224,14.224v229.27c0,7.855,6.366,14.225,14.224,14.225\r\n\tH248.082z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  id: "f",
  fill: "#FFFFFF",
  d: "M182.409,262.307v-99.803h33.499l5.016-38.895h-38.515V98.777c0-11.261,3.127-18.935,19.275-18.935\r\n\tl20.596-0.009V45.045c-3.562-0.474-15.788-1.533-30.012-1.533c-29.695,0-50.025,18.126-50.025,51.413v28.684h-33.585v38.895h33.585\r\n\tv99.803H182.409z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }